// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"8fa4c070","496":"f81bb5e5","520":"c782c833","903":"7e86d1a7","997":"8fa4c070"}[chunkId] + ".chunk.css";
};